import React from 'react';
import { IRenderThumbParams } from 'react-range/lib/types';
import styles from './custom-thumb.module.scss';
import clsx from 'clsx';

type Props = {
    params: IRenderThumbParams;
    values: number[];
    label?: string;
    maxVal: number;
};

const CustomThumb: React.FC<Props> = ({ params, values, label, maxVal, }) => {
    const { props, isDragged, value, index } = params;
    const [min, max] = values;
    const isSameValue = min === max;
    const leftOffset = isSameValue || value < max - 2 ? '-50%' : '-100%';
    const rightOffset = isSameValue || value > min + 2 ? '-50%' : '0';
    
    return (
        <div
            {...props}
            key={props.key}
            className={clsx(styles.thumb, isDragged && styles.isDragged)}
            style={{
                ...props.style,
            }}
        >
            <span
                className={
                    clsx(
                        styles.value,
                        label && styles.withLabel
                    )
                }
                style={{
                    transform: `translateX(${value === min ? leftOffset : rightOffset})`,
                }}>
                {/*{value}*/}
                {
                    [
                        ...(label ? [label] : []),
                        value >= maxVal ? `${maxVal}+` : value
                    ]
                        .join(' ')
                }
            </span>
        </div>
    );
};

export default CustomThumb;
